import { HTMLAttributes, ReactNode } from 'react';
import clsx from 'clsx';
import Footer from '../../components/Footer';
import { AuthenticatedHeader } from '../Header/AuthenticatedHeader';

type Props = HTMLAttributes<HTMLDivElement> & {
  children: ReactNode;
};

export const AuthenticatedPage = ({ children, className }: Props) => {
  const classname = clsx('authenticated-page mx-auto w-full', className);

  return (
    <div className={classname}>
      <AuthenticatedHeader />

      <div className="content">{children}</div>
      <Footer />
    </div>
  );
};

export default AuthenticatedPage;
